/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import type { RefObject, JSX } from 'preact';
import { classNames } from '#utils/UNSAFE_classNames';
import { styles as timeComponentStyles } from '#PRIVATE_TimeComponent/themes/TimeComponentStyles.css';
import { styles as ganttStyles } from './themes/GanttStyles.css';
import type { UnpackSignals } from '@oracle/oraclejet-internal-utilities/attributeUtils';
import { Size, sizeToCSS } from '#utils/UNSAFE_size';
import { type TestIdProps, useTestId } from '#hooks/UNSAFE_useTestId';

type IntrinsicProps = UnpackSignals<JSX.IntrinsicElements['div']>;
type Props = IntrinsicProps &
  TestIdProps & {
    innerRef: RefObject<HTMLDivElement>;
    width?: Size;
    height?: Size;
  };

export function GanttContainer({
  innerRef,
  width,
  height,
  testId,
  children,
  ...otherProps
}: Props) {
  const testIdProps = useTestId(testId);

  return (
    <div
      ref={innerRef}
      tabIndex={0}
      {...testIdProps}
      {...otherProps}
      class={classNames([timeComponentStyles.baseStyle, ganttStyles.baseStyle])}
      style={{ width: width && sizeToCSS(width), height: height && sizeToCSS(height) }}>
      {children}
    </div>
  );
}
